import { useState } from 'react';

import useContestInvite from '~/domains/contest/domains/invite/hooks/useContestInvite';
import type { ButtonProps } from '~/domains/design-system/Button';
import { useInvitesManagerEnabled } from '~/domains/invites-manager/hooks/useInvitesManagerEnabled';

import { InviteCTA } from './components/InviteCTA';
import InviteModal from './components/InviteModal';

type ContestInviteProps = Omit<ButtonProps, 'children'> & {
  contestId?: string;
  contestName?: string;
  ctaProps?: ButtonProps;
  onSuccess?: VoidFunction;
};

function ContestInvite({
  contestId,
  ctaProps,
  contestName,
  onSuccess,
  ...rest
}: ContestInviteProps) {
  const [opened, setIsOpened] = useState(false);
  const { isInviteCTAShown } = useContestInvite();
  const { isInvitesManagerEnabled, navigateToInvitesManager } = useInvitesManagerEnabled();
  if (!isInviteCTAShown) {
    return null;
  }

  if (!contestId && !contestName) {
    <InviteCTA disabled {...ctaProps} {...rest} />;
  }

  return (
    <>
      <InviteCTA
        contestId={contestId}
        onClick={() => {
          if (isInvitesManagerEnabled) {
            return navigateToInvitesManager(contestId);
          }
          return setIsOpened(true);
        }}
        isContestLoaded={!!contestName}
        {...ctaProps}
        {...rest}
      />
      <InviteModal
        opened={opened}
        onClose={() => setIsOpened(false)}
        onSuccess={onSuccess}
        contestId={contestId}
        contestName={contestName}
      />
    </>
  );
}

export default ContestInvite;
